module.exports = __webpack_public_path__ + "static/2015-22a51ab038d120c52b96048fe83162b9.png";